import { useHistory, useLocation } from "react-router-dom"

export const useRedirect = (id = null) => {
    const history = useHistory()

    const getRealPath = () => {
        const trimpath = ['add', '']
        const path = useLocation().pathname.split('/')
        const returnedArray = []
        returnedArray.push(path.shift())
        const lastAddOrEdit = path.findLastIndex(e => trimpath.includes(e))

        for (const [i, pa] of [...path.entries()]) {
            path.splice(lastAddOrEdit, 1)
            if (lastAddOrEdit !== i) returnedArray.push(pa)
        }
        const idNums = returnedArray.filter(m => { if (Number(m)) return m })
        if (idNums.length === 2) idNums.pop()
        if (idNums.length > 0) {
            if (Number(returnedArray[returnedArray.length - idNums.length])) {
                returnedArray.splice(idNums.length * (-1))
            }
        }
        return returnedArray.join('/')
    }

    const realPath = getRealPath(id)

    const redirectToEdit = (res, specificLocation = '') => {
        if (res) history.push(`${realPath}/${res.id}`)
    }

    const redirectToList = (specificLocation = null) => {
        const listPath = realPath.split('/')
        const checkNum = listPath.map(lp => parseInt(lp)).filter(f => !isNaN(f)) > 0
        if (checkNum) listPath.pop()
        history.push(!specificLocation ? listPath.join('/') : specificLocation)
    }

    return { redirectToEdit, redirectToList }
}
